// @flow
import * as Sentry from '@sentry/react'
import { PROD_ENV, SENTRY_DSN, VERSION, GIT_REVISION } from '@alphaott/smart-tv-config'

import { brandName } from '../containers/RootContainer/const'
import { registerSentryClient } from './sendStatus'
import { withCrashEventBypass } from './crashEvent'

if (PROD_ENV) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: `${VERSION}-${GIT_REVISION}`,
    environment: brandName,
    autoSessionTracking: false,
    sendClientReports: true,
    attachStacktrace: true,
    // Must stay 1.0: SDK sampling runs before beforeSend, so the crash-screen event
    // could not be kept from it
    sampleRate: 1.0,
    integrations: withCrashEventBypass,
    // eslint-disable-next-line complexity
    beforeSend(event, hint) {
      if (event.tags?.force_keep === '1') {
        return event
      }

      if (event.tags?.eventType === 'visibility_playback_exit') {
        // sampleRate
        if (Math.random() < 0.01) {
          return event
        }

        return null
      }

      const msg = event.message || event.exception?.values?.[0]?.value || ''

      if (/^TypeError: Failed to fetch$/i.test(msg)) {
        const orig = hint?.originalException

        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
          return null
        }

        if (
          orig?.name === 'AbortError' ||
          orig?.code === 20 ||
          (orig?.message && /signal/i.test(orig.message))
        ) {
          return null
        }
      }

      // sampleRate
      if (Math.random() < 0.05) {
        return event
      }

      return null
    },
    ignoreErrors: [
      /^Non-Error.*(promise|exception) captured/i,
      /^Object captured as (exception|promise rejection)/i,
      // Shaka network errors, also as "ShakaPlayer - 1001" or a bare code. No event is created for
      // them in the player; this is the backup
      /^(?:Shaka(?:\s?Error|Player)?\s*-?\s*)?(?:1001|1002|1003)(?!\d)/,
      /^Shaka(?:\s?Error)?\s?7001(?!\d)/,
      /^AbortError: The play\(\) request was interrupted/,
      "Cannot read properties of undefined (reading 'start')",
      "Cannot read properties of undefined (reading 'end')",
      "Cannot read property 'start' of undefined",
      "Cannot read property 'end' of undefined",
    ],
  })

  registerSentryClient(Sentry.getCurrentHub().getClient())
}

export default Sentry
